import { usePlatform } from "@platform//PlatformContext";
import { ProgramContainer } from "../../program/components/Program/ProgramContainer";
import { useDashboard } from "../DashboardContext";

export function DashboardProgramPage() {
  const { user } = usePlatform();

  const { program, organization } = useDashboard();

  return (
    <ProgramContainer
      program={program || null}
      user={user || null}
      organization={organization || null}
    />
  );
}

export default DashboardProgramPage;
